import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function LinkTab(props) {
  const { ...otherProps } = props;
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...otherProps}
      className="text-mont text-capitalize fs-6"
    />
  );
}

export default function TabBar(props) {
  const [value, setValue] = useState(0);
  const { tab, setSelectedTab } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        orientation={props.orientation || "horizontal"}
      >
        {tab
          .filter((el) => !el.admin)
          .map((el, id) => {
            return (
              <LinkTab
                disabled={el.disabled}
                icon={el.icon}
                label={el.label}
                key={id}
                onClick={() => setSelectedTab(el.tab)}
              />
            );
          })}
      </Tabs>
    </Box>
  );
}
